import { useTranslation } from "react-i18next";
import { Eye, EyeOff, Lasso } from "lucide-react";
import clsx from "clsx";
import type { SelectionAreasControlProps } from "./types";

export const SelectionAreasControl = ({
  count,
  canEdit,
  areAreasVisible,
  onOpenPanel,
  onToggleVisibility,
}: SelectionAreasControlProps) => {
  const { t } = useTranslation();

  const VisibilityIcon = areAreasVisible ? Eye : EyeOff;
  const hasAreas = count > 0;

  if (!canEdit && !hasAreas) return null;

  return (
    <div className="shrink-0 flex items-stretch rounded-lg border border-gray-300 overflow-hidden divide-x divide-gray-300">
      {canEdit && (
        <button
          type="button"
          onClick={onOpenPanel}
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-600 hover:text-blue-600 hover:bg-gray-50 transition-colors"
        >
          <Lasso className="w-3.5 h-3.5" />
          {t("smartSurveyor.selectionAreas.areasButton")}
          {hasAreas && (
            <span className="px-1.5 rounded-full bg-gray-100 text-gray-700">
              {count}
            </span>
          )}
        </button>
      )}
      {hasAreas && (
        <button
          type="button"
          onClick={onToggleVisibility}
          title={t(
            areAreasVisible
              ? "smartSurveyor.selectionAreas.hideAreas"
              : "smartSurveyor.selectionAreas.showAreas",
          )}
          className={clsx(
            "flex items-center px-2 py-1.5 transition-colors hover:bg-gray-50",
            areAreasVisible
              ? "text-blue-600 hover:text-blue-700"
              : "text-gray-400 hover:text-gray-600",
          )}
        >
          <VisibilityIcon className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};
